/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {defineBreadcrumbs} from '@ion/dls/src/components/breadcrumbs/BreadcrumbUtils';

/**
 * Builds the set of filter search results based on the specified matching
 * items.
 *
 * ```typescript
 * import {createFilterSearchResults} from '@ion/dls/src/filters';
 *
 * createFilterSearchResults = ({
 *   optionType,
 *   optionItems,
 *   optionData,
 *   crumbClasses
 * });
 *
 * ```
 */
export const createFilterSearchResults = ({
  optionType,
  optionItems,
  optionData,
  crumbClasses
}) => {
  const results = [];

  const getRawCrumbs = (itemId: string) => {
    const item = optionData[itemId];
    const rawCrumb = {
      label : item ? item.title : optionType,
      click : false
    };
    return item ? getRawCrumbs(item.parentId).concat([rawCrumb]) : [rawCrumb];
  };

  const makeCrumbRaw = (rawCrumbs) => {
    return rawCrumbs.reduce((acc, crumb) => {
      return `${acc}/${crumb.label}`;
    }, '');
  };

  optionItems.forEach(itemId => {
    const item          = optionData[itemId];
    const itemMap       = [itemId, item];
    const rawCrumbs     = getRawCrumbs(item.parentId);
    const thisCrumbRaw  = makeCrumbRaw(rawCrumbs);
    const found     = results.find(({crumbRaw}) => {
      return crumbRaw === thisCrumbRaw;
    });
    if (found) {
      found.items.push(itemMap);
    } else {
      results.push({
        crumb : defineBreadcrumbs({
          crumbs  : rawCrumbs,
          classes : crumbClasses
        }),
        crumbRaw : thisCrumbRaw,
        items    : [itemMap]
      });
    }
  });

  return results;
};
